module.exports = __webpack_public_path__ + "img/img_xinshou_8.cd791497.png";